import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { updateRule } from '../Rules/RulesActions';
import Button from 'ps-components/Button/Button';
import Input from 'ps-components/Input/Input';

import './SettingsModal.scss';

class SettingsModal extends Component {
  static propTypes = {
    modal: PropTypes.object,
    actions: PropTypes.object,
    updateRule: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = { lowerLimitEE: '', lowerLimitCO: '' };
  }

  UNSAFE_componentWillMount() {
    const { rule } = this.props.modalProps;
    if (rule) {
      this.setState({
        lowerLimitEE: rule.lowerLimitEE,
        lowerLimitCO: rule.lowerLimitCO
      });
    }
  }

  UNSAFE_componentWillUpdate(nextProps, nextState) {
    const { rule } = this.props.modal.modalProps;

    if (rule.id !== nextProps.modal.modalProps.rule.id) {
      this.setState({
        lowerLimitEE: nextProps.modal.modalProps.rule.lowerLimitEE,
        lowerLimitCO: nextProps.modal.modalProps.rule.lowerLimitCO
      });
    }
  }

  UNSAFE_componentWillUnmount() {
    this.setState({
      lowerLimitEE: '',
      lowerLimitCO: ''
    });
  }

  getValue(e, limit) {
    this.setState({ [limit]: e.target.value });
  }

  onSave = () => {
    const { actions, updateRule, history, modal } = this.props;
    const { rule } = modal.modalProps;
    const { lowerLimitEE, lowerLimitCO } = this.state;

    updateRule({ id: rule.id, lowerLimitCO, lowerLimitEE });
    history.goBack();
    actions.hideModal();
  };

  onCancel = () => {
    const { history, actions } = this.props;
    history.goBack();
    actions.hideModal();
  };

  render() {
    const { actions } = this.props;
    const { lowerLimitEE, lowerLimitCO } = this.state;
    return (
      <div className="settings__modal">
        <div className="settings__modal-title">Modify Settings</div>
        <div className="settings__modal-section">
          <div className="section__title">Participant size</div>
          <div className="section__item">
            Minimum &nbsp;
            <Input
              className="section__item-input"
              placeholder="e.g 100"
              onChange={e => this.getValue(e, 'lowerLimitCO')}
              type="number"
              value={lowerLimitCO}
            />
            &nbsp;Cos
          </div>
          <div className="section__item">
            Minimum &nbsp;
            <Input
              className="section__item-input"
              placeholder="e.g 100"
              onChange={e => this.getValue(e, 'lowerLimitEE')}
              type="number"
              value={lowerLimitEE}
            />
            &nbsp;Ees
          </div>
        </div>
        <div className="settings__modal-buttons">
          <a className="settings__modal-link" onClick={this.onCancel}>
            Cancel
          </a>
          <Button className="settings__modal-btn" onClick={this.onSave}>
            Save
          </Button>
        </div>
      </div>
    );
  }
}

export default connect(null, { updateRule })(SettingsModal);
